import axios from 'axios';

const state = {
	calendars: [],
};

const getters = {
	getCalendars: state => state.calendars,
};

const actions = {
	fetchRange: async (context, payload) => {
		const url = 'calendars/range';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{ start: payload.start, end: payload.end },
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
					timeout: 20000,
				},
			)
			.then(res => {
				context.commit('setCalendars', res.data.data);
				return res.data.data;
			})
			.catch(err => {
				console.log('errore', err);
				return [];
			});
	},

	fetchDetail: async (context, payload) => {
		const url = `calendars/detail/${payload}`;
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => res.data.data)
			.catch(err => {
				console.log('errore', err);
				return null;
			});
	},

	destroyData: context => {
		context.commit('setCalendars', []);
	},
};

const mutations = {
	setCalendars: (state, value) => {
		state.calendars = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
